
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gp86Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hhL3A")).default; });

var $hhL3A = parcelRequire("hhL3A");

});
parcelRegister("hhL3A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd5d4138f36a46c2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $8jdfl = parcelRequire("8jdfl");

var $j27rt = parcelRequire("j27rt");

var $gAJUc = parcelRequire("gAJUc");
const $fd5d4138f36a46c2$var$UniformFeatureGate = (props)=>{
    var _Object_entries_find;
    const { featureGateId: featureGateId, override: override } = props;
    const context = (0, $j27rt.useWAEContextSafe)();
    const featureGate = (_Object_entries_find = Object.entries((0, $gAJUc.featureFlags)).find(([, value])=>value.featureFlagName === featureGateId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: override
    });
    if (!featureGate) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? null : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jdfl.ManifestErrorMessage), {
                id: featureGateId
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "control"
            })
        ]
    });
    const showTreatment = (0, $gAJUc.checkFeatureFlagGate)(featureGate);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $fd5d4138f36a46c2$export$2e2bcd8739ae039 = $fd5d4138f36a46c2$var$UniformFeatureGate;

});
parcelRegister("8jdfl", function(module, exports) {

$parcel$export(module.exports, "ManifestErrorMessage", function () { return $641d3f539f73a96d$export$702dc26c1a322512; });

var $loA2J = parcelRequire("loA2J");

var $cUvUr = parcelRequire("cUvUr");
const $641d3f539f73a96d$export$702dc26c1a322512 = ({ id: id })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: id.length === 0 ? null : /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUvUr.default), {
            appearance: "error",
            isDismissible: true,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                        children: "Manifest entry not found for:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $loA2J.jsx)("code", {
                        children: id
                    }),
                    ". Rendering control slot."
                ]
            })
        })
    });
};

});



parcelRegister("iy0QV", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $d80c10498eafa0ae$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $d80c10498eafa0ae$export$2e2bcd8739ae039; });

var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $fiHN5 = parcelRequire("fiHN5");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $d80c10498eafa0ae$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $d80c10498eafa0ae$var$ExitingContext = /*#__PURE__*/ (0, $iSvIT.createContext)($d80c10498eafa0ae$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $d80c10498eafa0ae$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d80c10498eafa0ae$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d80c10498eafa0ae$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $d80c10498eafa0ae$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $iSvIT.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $d80c10498eafa0ae$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $d80c10498eafa0ae$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $d80c10498eafa0ae$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $d80c10498eafa0ae$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $d80c10498eafa0ae$var$ExitingPersistence = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $iSvIT.useState)([
        null,
        children
    ]), _useState2 = (0, $6omqE.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)([]), _useState4 = (0, $6omqE.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $6omqE.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $iSvIT.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $fiHN5.isReducedMotion)() && !(0, $jxLBU.fg)("platform_design_system_motion_on_finish_fix")) /**
     * We still want to use the `ExitingPersistence` with reduced motion,
     * otherwise the exiting `onFinish` is not called.
     */ return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, $6omqE.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $d80c10498eafa0ae$var$childrenToArray(previousChildren);
    var current = $d80c10498eafa0ae$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $d80c10498eafa0ae$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $d80c10498eafa0ae$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $d80c10498eafa0ae$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $d80c10498eafa0ae$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $d80c10498eafa0ae$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $iSvIT.useContext)($d80c10498eafa0ae$var$ExitingContext);
};
$d80c10498eafa0ae$var$ExitingPersistence.displayName = "ExitingPersistence";
var $d80c10498eafa0ae$export$2e2bcd8739ae039 = $d80c10498eafa0ae$var$ExitingPersistence;

});
parcelRegister("6omqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a7661e4a5e1a712$export$2e2bcd8739ae039; });

var $diQYQ = parcelRequire("diQYQ");

var $e6DER = parcelRequire("e6DER");

var $9qH2M = parcelRequire("9qH2M");

var $jEZdM = parcelRequire("jEZdM");
function $4a7661e4a5e1a712$export$2e2bcd8739ae039(r, e) {
    return (0, $diQYQ.default)(r) || (0, $e6DER.default)(r, e) || (0, $9qH2M.default)(r, e) || (0, $jEZdM.default)();
}

});
parcelRegister("diQYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9af60d9bbcc25a55$export$2e2bcd8739ae039; });
function $9af60d9bbcc25a55$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("e6DER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a67537c81e26fd$export$2e2bcd8739ae039; });
function $02a67537c81e26fd$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9qH2M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dd7ee60ffe99b59$export$2e2bcd8739ae039; });

var $5XjpQ = parcelRequire("5XjpQ");
function $6dd7ee60ffe99b59$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5XjpQ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5XjpQ.default)(r, a) : void 0;
    }
}

});
parcelRegister("5XjpQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $456186046ef97183$export$2e2bcd8739ae039; });
function $456186046ef97183$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("jEZdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5013e03c74628e9$export$2e2bcd8739ae039; });
function $e5013e03c74628e9$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fiHN5", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $b23a815ec1a4fd1c$export$b7baf7667a68d87c; });

var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");
var $b23a815ec1a4fd1c$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $b23a815ec1a4fd1c$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$b23a815ec1a4fd1c$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $b23a815ec1a4fd1c$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $iSvIT.useState)($b23a815ec1a4fd1c$export$b7baf7667a68d87c), _useState2 = (0, $6omqE.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        if (!$b23a815ec1a4fd1c$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $2e1kT.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $b23a815ec1a4fd1c$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $b23a815ec1a4fd1c$export$ff7706047246b98b = function prefersReducedMotion() {
    return $b23a815ec1a4fd1c$export$f0f789643ba5a83c;
};

});


parcelRegister("g2f6i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bac88be69adbc3f4$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $5OtVG = parcelRequire("5OtVG");
var $bac88be69adbc3f4$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $bac88be69adbc3f4$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $bac88be69adbc3f4$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5OtVG.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $bac88be69adbc3f4$export$2e2bcd8739ae039 = $bac88be69adbc3f4$var$FadeIn;

});
parcelRegister("5OtVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b8d6a2e59b3708$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $bAZii = parcelRequire("bAZii");

var $jxLBU = parcelRequire("jxLBU");

var $fiHN5 = parcelRequire("fiHN5");

var $6U1Ci = parcelRequire("6U1Ci");

var $irr0b = parcelRequire("irr0b");

var $iy0QV = parcelRequire("iy0QV");

var $24ZLM = parcelRequire("24ZLM");
var $43b8d6a2e59b3708$var$zoomIn = null;
var $43b8d6a2e59b3708$var$zoomOut = null;
var $43b8d6a2e59b3708$var$fadeIn = null;
var $43b8d6a2e59b3708$var$fadeOut = null;
var $43b8d6a2e59b3708$var$fadeInFromTop = null;
var $43b8d6a2e59b3708$var$fadeOutFromTop = null;
var $43b8d6a2e59b3708$var$fadeInFromLeft = null;
var $43b8d6a2e59b3708$var$fadeOutFromLeft = null;
var $43b8d6a2e59b3708$var$fadeInFromBottom = null;
var $43b8d6a2e59b3708$var$fadeOutFromBottom = null;
var $43b8d6a2e59b3708$var$fadeInFromRight = null;
var $43b8d6a2e59b3708$var$fadeOutFromRight = null;
var $43b8d6a2e59b3708$var$fadeInFromTopConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromTopConstant = null;
var $43b8d6a2e59b3708$var$fadeInFromLeftConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromLeftConstant = null;
var $43b8d6a2e59b3708$var$fadeInFromBottomConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromBottomConstant = null;
var $43b8d6a2e59b3708$var$fadeInFromRightConstant = null;
var $43b8d6a2e59b3708$var$fadeOutFromRightConstant = null;
var $43b8d6a2e59b3708$var$slideInFromTop = null;
var $43b8d6a2e59b3708$var$slideOutFromTop = null;
var $43b8d6a2e59b3708$var$slideInFromRight = null;
var $43b8d6a2e59b3708$var$slideOutFromRight = null;
var $43b8d6a2e59b3708$var$slideInFromBottom = null;
var $43b8d6a2e59b3708$var$slideOutFromBottom = null;
var $43b8d6a2e59b3708$var$slideInFromLeft = null;
var $43b8d6a2e59b3708$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $43b8d6a2e59b3708$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $24ZLM.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $iy0QV.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $irr0b.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $iSvIT.useState)(appear), _useState2 = (0, $6omqE.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $fiHN5.isReducedMotion)() && (0, $jxLBU.fg)("platform_design_system_motion_on_finish_fix")) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $6U1Ci.exitingDurations)[duration] : (0, $6U1Ci.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $bAZii.default)([
            (0, $bAZii.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $bAZii.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $bAZii.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $bAZii.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $bAZii.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $bAZii.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $bAZii.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $bAZii.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $bAZii.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $bAZii.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $bAZii.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $bAZii.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $bAZii.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $bAZii.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $bAZii.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $bAZii.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $bAZii.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $bAZii.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $bAZii.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $bAZii.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $bAZii.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $bAZii.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $bAZii.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $bAZii.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $bAZii.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $bAZii.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $bAZii.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $bAZii.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $bAZii.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $bAZii.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $bAZii.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $bAZii.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $bAZii.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $bAZii.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $bAZii.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $bAZii.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $bAZii.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $bAZii.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $bAZii.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $bAZii.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $bAZii.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $bAZii.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $bAZii.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $bAZii.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $bAZii.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $43b8d6a2e59b3708$export$2e2bcd8739ae039 = $43b8d6a2e59b3708$var$EnteringMotion;

});
parcelRegister("bAZii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87129a3646e53da3$export$2e2bcd8739ae039; });
const $87129a3646e53da3$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $87129a3646e53da3$var$ATOMIC_GROUP_LENGTH = 5;
function $87129a3646e53da3$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $87129a3646e53da3$var$UNDERSCORE_UNICODE ? $87129a3646e53da3$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("6U1Ci", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $50693a1294ca35e7$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $50693a1294ca35e7$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $50693a1294ca35e7$export$368bacef0dacbe05 = 25;
var $50693a1294ca35e7$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $50693a1294ca35e7$export$30fa1a2e62ae150c = {
    none: $50693a1294ca35e7$export$38b928a7167ce124.none,
    small: $50693a1294ca35e7$export$38b928a7167ce124.small * $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER,
    medium: $50693a1294ca35e7$export$38b928a7167ce124.medium * $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER,
    large: $50693a1294ca35e7$export$38b928a7167ce124.large * $50693a1294ca35e7$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("irr0b", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $d6cfb1a347635687$export$4f34107a2b00f39c; });

var $iSvIT = parcelRequire("iSvIT");
var $d6cfb1a347635687$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $d6cfb1a347635687$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d6cfb1a347635687$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $d6cfb1a347635687$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d6cfb1a347635687$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("24ZLM", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $183bdea3f5b943ba$export$25c7213fc07ec080; });

var $6omqE = parcelRequire("6omqE");

var $iSvIT = parcelRequire("iSvIT");

var $4OZuI = parcelRequire("4OZuI");

var $dotOx = parcelRequire("dotOx");

var $2qAxF = parcelRequire("2qAxF");
var $183bdea3f5b943ba$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $iSvIT.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $4OZuI.default)
    };
});
var $183bdea3f5b943ba$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $2qAxF.useUniqueId)();
    var context = (0, $iSvIT.useContext)($183bdea3f5b943ba$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $183bdea3f5b943ba$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $iSvIT.useRef)([]);
    var indexes = [];
    var _useState = (0, $iSvIT.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $6omqE.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $dotOx.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($183bdea3f5b943ba$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $183bdea3f5b943ba$export$2e2bcd8739ae039 = $183bdea3f5b943ba$var$StaggeredEntrance;

});
parcelRegister("dotOx", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $9c04a4b23e949986$export$e5c5a5f917a5871c; });

var $iSvIT = parcelRequire("iSvIT");
var $9c04a4b23e949986$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);

});

parcelRegister("2qAxF", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $1c4a5af7c249a3b2$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $iSvIT = parcelRequire("iSvIT");
function $1c4a5af7c249a3b2$export$c485849f2e393253() {
    var identifier = (0, $iSvIT.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});





//# sourceMappingURL=feature-gate.490cfd2c.js.map
